import { GroupsOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';

const MakePrivateDialog = ({
  onMakePrivate,
  isOpen,
  setIsOpen,
}: {
  onMakePrivate: () => void;
  isOpen: boolean;
  setIsOpen: (newValue: boolean) => void;
}) => {
  const handleMakePrivate = () => {
    onMakePrivate();
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: '#F52C00', display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <GroupsOutlined />
          {'Make this folder private?'}
        </DialogTitle>
        <DialogContent>
          This will unshare the folder with all users. You will be the only one who can access it.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleMakePrivate} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MakePrivateDialog;
